import { render, staticRenderFns } from "./Zug.vue?vue&type=template&id=7dcd9462"
import script from "./Zug.vue?vue&type=script&lang=js"
export * from "./Zug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports